import React from 'react';
import { EditorStringModel } from '../../Types/EditorString';
import EditorStringComponent from '../EditorString/EditorString';
import styled from 'styled-components';
import { fontFamilyBold, text } from '../../styling/mixins/typography';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { getColor } from '../../styling/mixins/colors';

interface ProductPageUspsProps {
  usps?: Usp[];
}

interface Usp {
  icon: string;
  alt: string;
  title: string;
  description: EditorStringModel;
}

const StyledProductPageUsp = styled.div`
  padding-bottom: 2.4rem;
  border-bottom: 1px solid ${getColor('grey', 300)};
  margin-bottom: 2.4rem;
`;

const StyledUspItem = styled.div`
  display: flex;
  align-items: center;
  &:not(:last-of-type) {
    margin-bottom: 1.2rem;
  }
  img {
    margin-right: 0.8rem;
  }
  .title {
    ${fontFamilyBold}
    margin-bottom: 0.2rem;
  }
  .text-content {
    ${text('small')}
    display: flex;
    flex: 1;
    flex-direction: column;
    ${breakpoint('medium')} {
      ${text('medium')}
    }
  }
`;

const ProductPageUsps = ({ usps }: ProductPageUspsProps) => {
  return (
    <StyledProductPageUsp>
      {usps?.map((usp) => (
          <StyledUspItem key={usp.title}>
              <img alt={usp.alt ?? usp.title} width={32} height={32} src={usp.icon} />
          <div className="text-content">
            {usp.title && <div className="title">{usp.title}</div>}
            {usp.description && <EditorStringComponent value={usp.description.value} />}
          </div>
        </StyledUspItem>
      ))}
    </StyledProductPageUsp>
  );
};

export default ProductPageUsps;
